import { Controller } from "@hotwired/stimulus"

// The giver's "Skjul kjøpte / Vis kjøpte" toggle: hides fully-bought wish cards.
//
//   %div{data: { controller: "toggle-bought" }}
//     %button{data: { action: "toggle-bought#toggle" }}
//       %span{data: { toggle_bought_target: "label" }} Skjul kjøpte
//     .lv-card{data: { toggle_bought_target: "container" }}
//       ... rows with .lv-row.bought, plus the .lv-allbought sibling ...
export default class extends Controller {
  static targets = ["container", "label", "iconShow", "iconHide"]

  toggle(event) {
    event.preventDefault()
    const hiding = !this.containerTargets[0].classList.contains("hide-bought")
    this.containerTargets.forEach((c) => c.classList.toggle("hide-bought", hiding))
    if (this.hasLabelTarget) this.labelTarget.textContent = hiding ? "Vis kjøpte" : "Skjul kjøpte"
    if (this.hasIconShowTarget) this.iconShowTarget.hidden = !hiding
    if (this.hasIconHideTarget) this.iconHideTarget.hidden = hiding
  }
}
